module.exports = __webpack_public_path__ + "img/eight1Green.ce7fdfb3.jpg";